import React from 'react';

const Pricingpopup = () => {
  return (
    <div className="p-6 text-gray-800">
      <div className="text-4xl mb-4 text-[#3D6643]">💰</div>
      <h2 className="text-2xl font-bold text-[#3D6643] mb-4">Smart Tariff & Pricing</h2>
      <p className="text-sm mb-4">
        Set flexible and smart pricing for your villas based on multiple criteria such as:
      </p>

      <ul className="list-disc list-inside text-sm mb-4 space-y-2">
        <li><strong>Weekday & Weekend Rates:</strong> Customize pricing based on the day of the week.</li>
        <li><strong>Seasonal Pricing:</strong> Adjust rates for peak and off-season dates (e.g., holidays, festivals, events).</li>
        <li><strong>Special Offers:</strong> Set up promotional discounts, early bird deals, or last-minute bookings.</li>
        <li><strong>Per Room or Per Guest:</strong> Flexible tariff per room or per person options.</li>
        <li><strong>Tax & Service Charges:</strong> Automatically calculate applicable taxes and charges.</li>
      </ul>

      <p className="text-sm">
        Stay Cool helps you optimize revenue by adjusting rates dynamically based on occupancy and demand. Simple, powerful, and built for villa owners.
      </p>
    </div>
  );
};

export default Pricingpopup;